// 对局观测 · 调用与费用：回合请求、平台调用索引、模型阶段、扣点与成本汇总、调用归属。

import { asArray } from './run-records.js'

/** 这个分支的回合请求，按开始时间升序。 */
export function branchRequests(snapshot, branch_id) {
  return Object.values(snapshot.requests ?? {})
    .filter((item) => item.branch_id === branch_id)
    .sort((a, b) => String(a.started_at ?? '').localeCompare(String(b.started_at ?? '')))
}

/** 平台调用按 llm_call_id 建索引。 */
export function indexCalls(calls) {
  const by_id = new Map()
  for (const call of calls) if (call.llm_call_id) by_id.set(call.llm_call_id, call)
  return by_id
}

/**
 * 模型阶段：快照里的调用记录（请求的 audits、任务的 calls）并上平台审计。
 * 快照记阶段、角色、状态、耗时与错误码；请求体、输出、首字、用量与成本只在平台审计里，按 call_id 取，取不到时 platform 为 null。
 */
export function modelStages(records, calls_by_id) {
  return asArray(records).map((record, index) => {
    const platform = record.call_id ? calls_by_id.get(record.call_id) ?? null : null
    return {
      key: `${index}:${record.call_id ?? record.task ?? ''}`,
      task: record.task ?? null,
      role: record.role ?? platform?.role ?? null,
      status: record.status ?? null,
      error_code: record.error_code ?? null,
      model: record.model ?? platform?.model ?? null,
      provider: record.provider ?? platform?.provider ?? null,
      elapsed_ms: record.elapsed_ms ?? null,
      platform,
    }
  })
}

/**
 * 这局累计向玩家扣的积分：已提交的回合请求（跨分支）记下的 charged_points 之和。
 * 请求一创建就记下扣点，失败与取消的请求由服务端退款，生成中的还没定局，三者都不计入。
 */
export function chargedPointsTotal(snapshot) {
  let total = 0
  for (const request of Object.values(snapshot.requests ?? {})) {
    if (request.status === 'committed') total += request.charged_points ?? 0
  }
  return total
}

/** 一组平台调用的汇总：调用数、出错数、按币种合计的供应商成本（百万分之一单位）与扣点。 */
export function callTotals(calls) {
  const cost_micros = {}
  let failed = 0
  let charged_points = 0
  for (const call of calls) {
    if (call.status === 'error') failed += 1
    if (call.supplier_cost_micros !== null && call.supplier_cost_micros !== undefined) {
      const currency = call.currency ?? ''
      cost_micros[currency] = (cost_micros[currency] ?? 0) + call.supplier_cost_micros
    }
    charged_points += call.charged_points ?? 0
  }
  return { count: calls.length, failed, cost_micros, charged_points }
}

/**
 * 调用的归属，跨全部分支：回合请求对应的回合序号、任务 id 对应的任务，
 * 以及快照按 call_id 记下的阶段记录（请求的 audits、任务的 calls），调用表据此补上阶段名与阶段错误码。
 */
export function callOwners(snapshot) {
  const turn_of_request = new Map()
  const job_by_id = new Map()
  const stage_by_call = new Map()
  for (const request of Object.values(snapshot.requests ?? {})) {
    for (const record of asArray(request.audits)) if (record.call_id) stage_by_call.set(record.call_id, record)
  }
  for (const branch of asArray(snapshot.branches)) {
    for (const turn of asArray(branch.turns)) if (turn.request_id) turn_of_request.set(turn.request_id, turn.seq)
    for (const job of asArray(branch.jobs)) {
      job_by_id.set(job.job_id, job)
      for (const record of asArray(job.calls)) if (record.call_id) stage_by_call.set(record.call_id, record)
    }
  }
  return { turn_of_request, job_by_id, stage_by_call }
}
